import React from 'react';


const InvalidLink = () => {

    const style = {maxWidth: '520px'};

    return (
        <section className="hero is-fullheight alva-bg">
            <div className="hero-body">
                <div className="container">
                    <div className="content" style={style}>
                        <h4>An error occurred</h4>
                        <p>This is most likely because of one of two things:</p>
                        <ol>
                            <li>You clicked on an invalid link.</li>
                            <li>You requested a  view that you do not have access to.</li>
                        </ol>

                        <p>Please write to us and tell us what happened. The easiest way is to use the chat down in the right corner.</p>

                        <p>Go back to <a href={'/o'}>home</a>.</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default InvalidLink;

